import FetchBase from '../Api/FetchBase'
import { observable, action } from 'mobx'
import {
  API_ENDPOINTS,
  DEFAULT_PAGE_START,
  DEFAULT_PER_PAGE_RECORD,
} from '../Utils/constants'

export default class NotificationsStore extends FetchBase {
  @observable noticiationsLoader = false
  @observable notificationsPageNo = DEFAULT_PAGE_START
  @observable notificationBadgeVisible = false
  @observable notificationsFinished = false
  @observable notificationsCurrent = 0
  @observable notifications = []

  @action.bound
  updateNotificationsPage = () => {
    if (this.notificationsLoader) {
      return false
    }
    if (this.notificationsFinished) {
      return false
    } else {
      this.setNotificationsPage(this.notificationsPageNo + 1)
      return true
    }
  }

  @action.bound
  setNotificationsPage = (page = DEFAULT_PAGE_START) => {
    this.notificationsPageNo = page
  }

  @action.bound
  setNotificationBadge = (value = false) => {
    this.notificationBadgeVisible = value
  }

  @action.bound
  getMyNotifications = async () => {
    try {
      this.noticiationsLoader = true
      this.setNotificationBadge()
      let response = await this.get(API_ENDPOINTS.GET_NOTIFICATIONS_LIST, {
        pageNo: Math.max(this.notificationsPageNo - 1, 0),
      })
      if (response.status) {
        this.notifications = [...this.notifications, ...response.data]
        if (response.data?.length) {
          return [true, response.data]
        } else {
          this.notificationsFinished = true
          return [true, response.data]
        }
      }
      return [false, undefined]
    } catch (err) {
      this.setNotificationsPage(this.notificationsPageNo - 1)
      return [false, undefined]
    } finally {
      this.noticiationsLoader = false
    }
  }

  @action.bound
  resetNotifications = () => {
    this.resetStore()
  }

  @action.bound
  resetStore = () => {
    this.noticiationsLoader = false
    this.notificationsPageNo = DEFAULT_PAGE_START
    this.notificationBadgeVisible = false
    this.notificationsFinished = false
    this.notificationsCurrent = 0
    this.notifications = []
  }
}
